export class PolylinePoint {
    constructor() {
        this._next = null;
        this.prev = null;
    }
    get point() {
        return this._point;
    }
    set point(value) {
        this._point = value;
    }
    get next() {
        return this._next;
    }
    set next(value) {
        this._next = value;
    }
    get nextOnPolyline() {
        return this.polyline.next(this);
    }
    get prevOnPolyline() {
        return this.polyline.prev(this);
    }
    //
    getNext() {
        return this.next;
    }
    setNext(nVal) {
        this.next = nVal;
        if (this.polyline != null)
            this.polyline.setInitIsRequired();
    }
    //
    getPrev() {
        return this.prev;
    }
    setPrev(prevVal) {
        this.prev = prevVal;
        if (this.polyline != null)
            this.polyline.setInitIsRequired();
    }
    static mkFromPoint(p) {
        const pp = new PolylinePoint();
        pp.point = p;
        return pp;
    }
}
//# sourceMappingURL=polylinePoint.js.map